import { Toast, ToastBody, ToastTitle } from "@fluentui/react-components";

export const ToastWithoutAction = ({
  title,
  message,
}: {
  title: string;
  message: string;
}) => (
  <Toast>
    <ToastTitle>{title}</ToastTitle>
    <ToastBody>{message}</ToastBody>
  </Toast>
);
